(() => {
  const giftVariantIds = [50633304473797, 42781993795781];
  const giftProperty = '_viajeros_regalo_termo';
  let syncing = false;

  const route = (path) => {
    const root = window.routes?.root || window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;
  };

  const getCart = async () => {
    const response = await fetch(route('cart.js'), {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('No fue posible consultar el carrito.');
    return response.json();
  };

  const isPromotionalGift = (item) => {
    return giftVariantIds.includes(Number(item.variant_id)) && item.properties?.[giftProperty] === 'true';
  };

  const refreshThemeCart = (cart, showDrawer) => {
    const detail = { ...cart, viajerosGiftSync: true };
    document.dispatchEvent(new CustomEvent('cart:update', { detail }));
    document.querySelectorAll('cart-items').forEach((cartItems) => {
      if (showDrawer && typeof cartItems.renderAndShowItems === 'function') {
        cartItems.renderAndShowItems();
      } else if (typeof cartItems.renderItems === 'function') {
        cartItems.renderItems();
      }
    });
  };

  const withoutGift = async (items) => items;

  const sync = async (showDrawer = false) => {
    if (syncing) return;
    syncing = true;

    try {
      let cart = await getCart();
      const promotionalGiftLines = cart.items.filter(isPromotionalGift);
      if (!promotionalGiftLines.length) return;

      for (const giftLine of promotionalGiftLines) {
        const response = await fetch(route('cart/change.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: giftLine.key, quantity: 0 }),
        });
        if (!response.ok) throw new Error('No fue posible retirar el mapa promocional.');
      }

      cart = await getCart();
      refreshThemeCart(cart, showDrawer);
    } catch (error) {
      console.error(error);
    } finally {
      syncing = false;
    }
  };

  window.ViajerosTermoGift = { withGift: withoutGift, sync };

  document.addEventListener('cart:update', (event) => {
    if (!event.detail?.viajerosGiftSync) sync(true);
  });
  window.addEventListener('pageshow', () => sync(false));
})();
